import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

import '../../../z-shader.scss';

const ZShaderMatrialComponent = ({zobject, fragmentShader, vertexShader}) => { 
    let [uniforms, setUniforms] = useState(zobject.effect.uniforms);
    let [creating, setCreating] = useState(false);
    let [name, setName] = useState('');
    let [value, setValue] = useState(0);
    let keys = Object.keys(uniforms || {});

    const onClickDone = useCallback(() => {
        zobject.effect.createUniform(name, value);
        setUniforms({... zobject.effect.uniforms});
        setCreating(false);
    }, [setUniforms, setCreating, value, name, setCreating]);

    return (
        <div className="zshader-material">
          {creating &&
           <div className="creating-uniform">
             <div className="create-row">
               <div className="label">
                 Name
               </div>
               <input type="text" value={name} onChange={e => setName(e.target.value)}/>
             </div>
             <div
               onClick={onClickDone}
               className="done-btn">
               Done
             </div>
           </div>}
          <div className="material-title">
            Shader Material
          </div>
          <div
            onClick={() => setCreating(true)}
            className="new-uniform-button">New Uniform</div>
          <div className="uniforms">
            {keys.map(
                name =>
                    <div className="uniform">
                      {name}: {stringify(uniforms[name].value)}
                    </div>
            )}
          </div>
          <div className="shaders">
            <div className={vertexShader ? "enabled shader": "shader"}>Vertex <div className="dot"/></div>
            <div className={fragmentShader ? "enabled shader": "shader"}>Fragment <div className="dot"/></div>
          </div>
        </div>
    );
};

const stringify = (str) => {
    if (typeof str === "number" || typeof str === "string") {
        return str;
    }
    return JSON.stringify(str);
};
const mapStateToProps = (state, props) => {
  return {
      fragmentShader: props.zobject.effect.fragmentShader,
      vertexShader: props.zobject.effect.vertexShader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZShaderMatrialComponent);
